import { eCommentType } from './eCommentType';

export const vendorCommentTypes = [eCommentType.titleSearch, eCommentType.payoff, eCommentType.taxCertification];
